import type { PropsWithChildren } from 'react';
import { SignedIn, SignedOut, UserButton } from '@clerk/clerk-react';
import { Link } from 'react-router-dom';
import { playClawHomeUrl } from '@/lib/redirects';

type AccountShellLayoutProps = PropsWithChildren;

const AccountShellLayout = ({ children }: AccountShellLayoutProps) => {
  const accountHomeLabel = 'DwellBot Account';
  const accountHomePath = '/';
  const playClawLinkLabel = 'Open Play Claw';
  const playClawLinkUrl = playClawHomeUrl;
  const signInPath = '/sign-in';
  const signInLabel = 'Sign in';
  const eyebrow = 'Account';
  const title = 'Manage the account you use for Play Claw.';
  const body = 'Update your profile, session security, and sign-in settings without leaving the DwellBot account domain.';

  return (
    <div className="auth-site-shell auth-site-shell--account">
      <div className="auth-site-shell__background auth-site-shell__background--top" />
      <div className="auth-site-shell__background auth-site-shell__background--left" />
      <div className="auth-site-shell__background auth-site-shell__background--right" />
      <div className="auth-site-shell__content auth-site-shell__content--account">
        <header className="account-shell__header">
          <Link className="account-shell__brand" to={accountHomePath}>
            <span className="account-shell__brand-eyebrow">DwellBot Games</span>
            <span className="account-shell__brand-name">{accountHomeLabel}</span>
          </Link>
          <div className="account-shell__actions">
            <a className="button button--secondary" href={playClawLinkUrl}>
              {playClawLinkLabel}
            </a>
            <SignedOut>
              <Link className="button button--ghost" to={signInPath}>
                {signInLabel}
              </Link>
            </SignedOut>
            <SignedIn>
              <div className="account-shell__user-button">
                <UserButton afterSignOutUrl={signInPath} />
              </div>
            </SignedIn>
          </div>
        </header>
        <main className="account-shell__main">
          <section className="account-shell__intro">
            <p className="account-shell__eyebrow">{eyebrow}</p>
            <h1 className="account-shell__title">{title}</h1>
            <p className="account-shell__body">{body}</p>
          </section>
          <div className="account-shell__content-surface">{children}</div>
        </main>
      </div>
    </div>
  );
};

export default AccountShellLayout;
